import React from 'react';
import { ChevronsDownUp, ChevronsUpDown, GitBranchPlus, ListPlus, Pencil, Trash2, CircleCheckBig } from 'lucide-react';
import { cn } from '../../utils/cn';

const ToolButton = ({ icon: Icon, label, onClick, active = false, primary = false, destructive = false }) => (
  <button
    type="button"
    aria-label={label}
    title={label}
    aria-pressed={active || undefined}
    onClick={onClick}
    className={cn(
      'inline-flex h-11 min-w-11 items-center justify-center gap-1.5 rounded-xl px-3 text-sm font-medium transition-colors',
      primary && 'bg-primary text-primary-foreground hover:bg-primary/90',
      !primary && !destructive && 'text-foreground hover:bg-accent',
      !primary && destructive && 'text-destructive hover:bg-destructive/10',
      active && !primary && 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400'
    )}
  >
    <Icon className="h-5 w-5" />
    {primary && <span className="hidden sm:inline">Add idea</span>}
  </button>
);

const MindMapToolbar = ({ node, isRoot, hasChildren, onAddChild, onAddSibling, onEdit, onToggleDone, onToggleCollapse, onDelete }) => (
  <div className="pointer-events-none absolute inset-x-0 bottom-0 z-10 flex justify-center px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
    <div
      role="toolbar"
      aria-label="Idea actions"
      className="pointer-events-auto flex items-center gap-1 rounded-2xl border border-border bg-background/95 p-1.5 shadow-lg backdrop-blur"
    >
      <ToolButton icon={GitBranchPlus} label="Add idea" onClick={onAddChild} primary />
      {!isRoot && <ToolButton icon={ListPlus} label="Add sibling" onClick={onAddSibling} />}
      <ToolButton icon={Pencil} label="Notes & color" onClick={onEdit} />
      <ToolButton icon={CircleCheckBig} label={node.done ? 'Mark not done' : 'Mark done'} onClick={onToggleDone} active={node.done} />
      {hasChildren && (
        <ToolButton
          icon={node.collapsed ? ChevronsUpDown : ChevronsDownUp}
          label={node.collapsed ? 'Expand branch' : 'Collapse branch'}
          onClick={onToggleCollapse}
        />
      )}
      {!isRoot && <ToolButton icon={Trash2} label="Delete idea and its branch" onClick={onDelete} destructive />}
    </div>
  </div>
);

export default MindMapToolbar;
